export default "__VITE_ASSET__Cg4UEn5b__"